<div class="bcg">

    <div class="d-flex justify-content-between custom-container mt-2">
        <nav class="custom-nav">
            <ol class="breadcrumb m-2">
                <li class="breadcrumb-item" style="cursor: pointer;" (click)="gotoDashboard()">Dashboard </li>
                <li class="breadcrumb-item active"  style="cursor: context-menu;" aria-current="page">User Management</li>
            </ol>
        </nav>
        <div class="dropdown-container">
            <app-dropdown [options]="cities" [(ngModel)]="selectedCity" placeholder="All branches" optionLabel="name"
                [showClear]="true"
                [style]="{
                    width: '240px',
                    height: '32px',
                    display: 'flex',
                    'align-items': 'center',
                    'border-radius': '10px'}"></app-dropdown>
        </div>
    </div>

    
<div class="page_responsive card mt-3">
    <div class="card-body">
      <div class="row">
        <span class="col-6 card-title title_header">Add new users </span>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <p style="margin-top: 25px; font-size: 13px;">
           Lorem ipsum dolar sit (one line description of the service)
          </p>
        </div>

        <div>
          <!-- <button
            class="button-style"
            (click)="savePersonalDetails()"
            type="button">
            <i class="bx bx-plus-circle" style="position: absolute; margin-top:3px;padding-right: 110px;"></i>
            <span > Bulk Upload </span>
          </button> -->

          <div class="button-style">
             <!-- <i class="bx bx-plus-circle" style="position: absolute; margin-top:10px;margin-left:10px;font-size: 1.1rem !important;"></i> -->
            <span><label  for="file-upload" class="file-upload-button">
              Bulk Upload 
               <input   id="file-upload" type="file" (change)="onFileSelected($event)">
             </label>
           </span> 
           </div>

        </div>
      </div>
    </div>
  </div>


  <div>
    <form [formGroup]="estampDetails">
     <div>
       <div class="card  mt-3">
         <div class="card-body">
           
           <div formArrayName="documentDetailsForm">  
             <section *ngFor="let details of documentDetailsArray().controls; let documentDetailsIndex=index"
             [formGroupName]="documentDetailsIndex">
             <div class="mt-1 pb-3">
                     <h5 class="title_five">User {{documentDetailsIndex +1}}</h5>
                     <!-- <strong class="m-1 mt-2 title_header_0">E-stamp {{documentDetailsIndex +1}}</strong> -->
                     
                     <div class="row form_inputFields">
                         <div class="col-lg-4 col-sm-4 col-md-4">
                           <span  class="form_field">First Name</span><span class="color_red">*</span>
                             <input 
                             [readOnly]="readOnlyName[documentDetailsIndex]"   class="form-control " formControlName="firstPartyName" placeholder="Enter Name"
                                    pInputText type="text">
                                <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('firstPartyName')?.hasError('required')">*Maximum of 100 characters </span>
                             
                              
                             </div><div class="col-lg-4 col-sm-4 col-md-4">
                               <span  class="form_field">Last Name</span><span class="color_red">*</span>
                                 <input 
                                     [readOnly]="readOnlyName[documentDetailsIndex]" placeholder="Enter Name"   class="form-control " formControlName="secondPartyName"
                                        pInputText type="text">
                                    <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('secondPartyName')?.hasError('required')">*Maximum of 100 characters </span>
                     
                                  
                             </div><div class="col-lg-3 col-sm-3 col-md-3">
                               <span  class="form_field">Email</span><span class="color_red">*</span>
 
                                     <input 
                                     [readOnly]="readOnlyName[documentDetailsIndex]"  placeholder="Enter Detail"   class="form-control " formControlName="stampDutyPaidBy"
                                            pInputText type="text">
                                        <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('stampDutyPaidBy')?.hasError('required')">*Maximum of 100 characters </span>
                         
                                      
                                 </div>
                                 <div  class="col-lg-1 col-sm-1 col-md-1 remove_btn">
                                   <!-- <button pButton pRipple type="button" icon="pi pi-trash" (click)="removeDetails(documentDetailsIndex)"
                                           class="p-button-trash"></button> -->

                                           <div class="d-flex justify-content-end me-2">
                                            <i (click)="removeDetails(documentDetailsIndex)" class='bx bx-trash-alt'></i>
                                        </div>
                                 </div>
                     </div>
                     <div class="row form_inputFields">
                     <div class="col-lg-4 col-sm-4 col-md-4">
                       <span  class="form_field">Mobile Number</span><span class="color_red">*</span>
 
                             <input 
                                    class="form-control " formControlName="stampDutyValue" placeholder="Enter Description"
                                    pInputText type="number" (keypress)="numberOnly($event)">
                                <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('stampDutyValue')?.hasError('required')"></span>
                 
                           
                             </div><div class="col-lg-4 col-sm-4 col-md-4">
                               <span  class="form_field">Password</span><span class="color_red">*</span>
 
                                 <input 
                                        class="form-control " formControlName="purposeOfStampDuty" placeholder="Enter Detail"
                                        pInputText type="text">
                                    <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('purposeOfStampDuty')?.hasError('required')">*Maximum of 100 characters </span>
                     
                                 
                             </div><div class="col-lg-3 col-sm-3 col-md-3">
                               <span  class="form_field">Confirm Password</span><span class="color_red">*</span>
 
                                     <input 
                                            class="form-control " formControlName="NoOfCopies" placeholder="Enter Detail"
                                            pInputText type="number" (keypress)="numberOnly($event)" maxlength="2">
                                        <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('NoOfCopies')?.hasError('required')">**Maximum of 3 characters </span>
                         
                                     
                                 </div>
                     </div>
                     <div class="row form_inputFields">
                       <div class="col-lg-4 col-sm-4 col-md-4">
                         <span  class="form_field">Role</span><span class="color_red">*</span>
                               <input 
                                      class="form-control " formControlName="considerationPrice" placeholder="Branch Admin"
                                      pInputText type="number" (keypress)="numberOnly($event)" >
                                  <span class="p-error"  *ngIf="submitted && documentDetailsArray().at(documentDetailsIndex).get('considerationPrice')?.hasError('required')"></span>  
                           </div>
                           <div class="col-lg-4 col-sm-4 col-md-4">
                             <span class="form_field ms-2">Branch</span>
                             <span class="color_red">*</span>
                             <div style="display: block">
                               <app-dropdown  class="custom-dropdown" placeholder="Coimbatore" [autoDisplayFirst]="false" optionLabel="name" optionValue="name" formControlName="articleNumber"></app-dropdown>
                             </div>
                           </div>
                           
                  
                         
                     </div>                                                  
                   </div>
                   
                 </section>
                 <div class="row ">
                     <div class="col-2 custom_button_2">
                      <button
                      class="button-style-1"
                      type="button">
                      <i class="bx bx-plus-circle" style="position: absolute; margin-top:2px;font-size: 1.1rem !important;"></i>
                      <span style="padding-left: 24px;"  (click)="addNewDetails()"> Add New User </span>
                    </button>
                     </div>


                   <!-- <div class="col-9"></div>
                     <div class="col-1 custom_button">
                       <p-button label="Save" (click)="nextStepSign()"  styleClass="p-button-sm-outline"></p-button>
                       
                     </div> -->
                  

                     <div class="d-flex justify-content-end px-4 mb-3">
                      <div>
                          <button style="font-size: 15px;" type="button"  [routerLink]="'/doqfy/userManagement/form'" class="btn btn-outline-custom me-4 ">Back</button>
                      </div>
          
          
                      <div>
                          <button class="button-style-save"(click)="nextStepSign()"   type="button">Save</button>
                      </div>
                  </div>


                 </div>
                
                        
                 </div>
            
         </div>
       </div>
      </div>
    </form>

  
    
          

</div>

<div class="toast_display_layer">
 <p-toast></p-toast>
</div>



</div>